import React, { useState } from "react";
import Button from "@mui/material/Button";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import InfoTooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";

// Controls shared by Report Library reports: an info-icon definition (hover,
// keyboard focus, tap, Escape, click-away) and a labelled view switch.

export function Info({ label, children }) {
  const [open, setOpen] = useState(false);
  return <ClickAwayListener onClickAway={() => setOpen(false)}><span className="inline-flex align-middle">
    <InfoTooltip title={children} open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} describeChild disableTouchListener>
      <IconButton size="small" aria-label={`About ${label}`} onClick={() => setOpen(!open)} onKeyDown={(e) => { if (e.key === "Escape") setOpen(false); }}><InfoOutlined sx={{ fontSize: 17 }} /></IconButton>
    </InfoTooltip>
  </span></ClickAwayListener>;
}

export function Switch({ label, value, options, onChange }) {
  return <div role="group" aria-label={label} className="flex flex-wrap gap-2">{options.map(([key, name]) => <Button key={key} size="small" variant={value === key ? "contained" : "outlined"} aria-pressed={value === key} sx={{ textTransform: "none" }} onClick={() => onChange(key)}>{name}</Button>)}</div>;
}
